import React from "react";
import Shared from "src/components/Shared";
import { useAuth } from "src/context/Auth/context";

const Layout: React.FC = ({ children }) => {
	const {user} = useAuth();

	return (
		<>
			{user ? (
				<Shared>
					{children}
				</Shared>
			) : 
				<>
					{children}
				</>
			}
		</>
	);
};

export default Layout;
